import { Injectable } from '@angular/core';

declare global {
  interface Window { integra: any; }
}

@Injectable({
  providedIn: 'root'
})
export class WebSocketConfigService {
  // server URL
  public url: string = window.integra.webSocket?.url;
  // ping interval (default every 1 minute)
  public pingInterval: number = window.integra.webSocket?.pingInterval || 60000;
  // ping timeout (default 10 seconds), if no pong is received, the connection is closed
  public pingTimeout: number = window.integra.webSocket?.pingTimeout || 10000;
  // WebSocket enabled flag (defaults to true if not explicitly set to false)
  public isEnabled: boolean = window.integra?.webSocket?.isEnabled !== false;
}
